import Auth from "../utils/auth";

export default {
	name: 'ModuleBox',
	components: {

	},
	data(){
		return{


		}
	},
	methods:{

	},
	mounted(){
		
	}
}